export const LANDING_TITLE = 'Shuttlr - Badminton nights, sorted.';
export const LANDING_DESCRIPTION = 'Sign up, play, and see your games.';

export const demoSession = {
  clubName: 'Riverside Badminton Club',
  venue: 'Riverside Sports Centre',
  subtitle: 'Friendly doubles · All levels',
  when: 'Sat, 16 Aug · 18:00 – 20:00',
  spotsLeft: 6,
};

export const demoPerformance = {
  winRate: 72,
  elo: 1482,
  eloDelta: 12,
  gamesPlayed: 18,
};

export const demoClub = {
  name: 'Riverside Badminton Club',
  members: 62,
  activity: '10+ active members',
};

export const demoLeaderboard = [
  { rank: 1, name: 'Alex Chen', elo: 1547, gender: 'male', rankDelta: 2 },
  { rank: 2, name: 'Samira Khan', elo: 1512, gender: 'female', rankDelta: -1 },
  { rank: 3, name: 'Jordan Lee', elo: 1482, gender: 'male', rankDelta: 1 },
  { rank: 4, name: 'Priya Nair', elo: 1461, gender: 'female', rankDelta: 0 },
  { rank: 5, name: 'Chris Walsh', elo: 1433, gender: 'male', rankDelta: 3 },
];

export const demoLiveCourt = {
  label: 'Court 1',
  score: [14, 11],
  team1: {
    avgElo: 1504,
    players: [
      { name: 'Alex Chen', elo: 1547, gender: 'male' },
      { name: 'Priya Nair', elo: 1461, gender: 'female' },
    ],
  },
  team2: {
    avgElo: 1497,
    players: [
      { name: 'Samira Khan', elo: 1512, gender: 'female' },
      { name: 'Jordan Lee', elo: 1482, gender: 'male' },
    ],
  },
};

export const demoUpNext = {
  label: 'Up next',
  team1: [
    { name: 'Chris Walsh', elo: 1433, gender: 'male' },
    { name: 'Maya Ortiz', elo: 1418, gender: 'female' },
  ],
  team2: [
    { name: 'Ben Cole', elo: 1406, gender: 'male' },
    { name: 'Aisha Rahman', elo: 1394, gender: 'female' },
  ],
};
